import React, { useState, useContext } from "react";
import * as api from "../../../api/apiConnector.js";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

import { iconMapping } from "../../../components/fileTypeNames.js";
import UserContext from "../../../components/User_Context.js";
import { useEditPanelContext } from "./edit_panel_context.js";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import AsyncSelect from "react-select/async";

function FileInfo() {
  const {
    item,
    setItem,
    toSave,
    setToSave,
    isSavingRightEditModal,
    setIsSavingRightEditModal,
    // vocabs
    dmsClassificationVoc,
    dmsCategoriesVoc,
    dmsValidationFlowVoc,
    dmsFileKeywords,
    allKeywords,
    // selections
    selectedClassifications,
    setSelectedClassifications,
    selectedValidation,
    setSelectedValidation,
    selectedCategories,
    setSelectedCategories,
    selectedFileKeywords,
    setSelectedFileKeywords,
    selectedOrganizationUnitIds,
    setSelectedOrganizationUnitIds,
    // utils
    getItemSize,
    userRights,
  } = useEditPanelContext();

  const { t } = useTranslation("labels");
  const { currentUser } = useContext(UserContext);
  const [keywordsInput, setKeywordsInput] = useState("");

  

  const searchOrganizationUnits = async (inputValue) => {
    const query = String(inputValue ?? "").trim();
    if (query.length === 0) return [];

    try {
      const result = await api.sendMessage(
        "admin/system/organization/searchSmallBusinessUnit",
        {
          user: currentUser(),
          body: {
            text: query,
          },
        }
      );
      if (result.success) {
        const units = Array.isArray(result?.units) ? result.units : [];
        return units.map((o) => ({
          label: o?.name ?? o?.Name ?? "",
          value: o?.id ?? o?.Id ?? "",
        }));
      }
    } catch (error) {
      console.error("Error searching organization units:", error);
      return [];
    }
  };


  const closeOffcanvas = () => {
    const closeBtn = document.querySelector("#editPanel .btn-close");
    if (closeBtn) {
      closeBtn.click();
      return;
    }
    const el = document.getElementById("editPanel");
    if (el && window.bootstrap?.Offcanvas) {
      const oc =
        window.bootstrap.Offcanvas.getInstance(el) ||
        new window.bootstrap.Offcanvas(el);
      oc?.hide();
    }
  };

  const updateRightModalDetails = async () => {
    if (!item?.item?.Id) return;
    const isFile = item?.type === "file";

    try {
      if (isFile) {
        const body = {
          id: item.item.Id,
          name: item.item.Name,
          expirationDate: item.item.ExpirationDate ?? null,
          classifications: (selectedClassifications || []).map((c) => ({
            ClassificationCode: c.Code,
          })),
          categories: (selectedCategories || []).map((c) => ({
            CategoryCode: c.Code,
          })),
          fileStatus: selectedValidation?.Code,
          keywords: (selectedFileKeywords || []).map((k) => k?.Keyword ?? k),
          organizationUnitId: selectedOrganizationUnitIds?.value,
        };
          // DRAFT - PND - 
        const result = await api.sendMessage("dms/updateFile", {
          user: currentUser(),
          body,
        });

        if (result?.success) {
          setToSave(false);
          closeOffcanvas();
          withReactContent(Swal)
            .fire({
              title: "Success",
              icon: "success",
              text:
                t("fileUpdatedSuccessfully", { ns: "labels" }) ||
                "File updated successfully",
              showConfirmButton: true,
              confirmButtonText: "Close",
            })
            .then(() => {
              closeOffcanvas();
              window.location.reload();
            });
        } else {
          withReactContent(Swal)
            .fire({
              title: t("error", { ns: "labels" }),
              icon: "error",
              text:
                result?.error ||
                result?.message ||
                t("updateError", { ns: "labels" }) ||
                "Error updating file",
              showConfirmButton: true,
            })
            .then(() => {
              closeOffcanvas();
              window.location.reload();
            });
        }
      } else {
        const result = await api.sendMessage("dms/renameFolder", {
          user: currentUser(),
          body: {
            id: item.item.Id,
            name: item.item.Name,
          },
        });

        if (result?.success) {
          setToSave(false);
          closeOffcanvas();
          withReactContent(Swal)
            .fire({
              title: "Success",
              icon: "success",
              text:
                t("folderUpdatedSuccessfully", { ns: "labels" }) ||
                "Folder updated successfully",
              showConfirmButton: true,
              confirmButtonText: "Close",
            })
            .then(() => {
              closeOffcanvas();
              window.location.reload();
            });
        } else {
          withReactContent(Swal)
            .fire({
              title: t("error", { ns: "labels" }),
              icon: "error",
              text:
                result?.error ||
                result?.message ||
                t("updateFolderError", { ns: "labels" }) ||
                "Error updating Folder",
              showConfirmButton: true,
            })
            .then(() => {
              closeOffcanvas();
              window.location.reload();
            });
        }
      }
    } catch (error) {
      withReactContent(Swal)
        .fire({
          title: t("error", { ns: "labels" }),
          icon: "error",
          text:
            t("updateFolderError", { ns: "labels" }) || "Error updating Folder",
          showConfirmButton: true,
        })
        .then(() => {
          closeOffcanvas();
          window.location.reload();
        });
    }
  };

  const _drawClassificationsChoices = () => {
    return (
      <div className="row pt-3" style={{ cursor: "pointer" }}>
        <div className="col-xl">
          <h5 className="form-label">
            {t("classification", { ns: "labels" })}
          </h5>
          {dmsClassificationVoc.length > 0 ? (
            <Select
              isMulti
              options={dmsClassificationVoc}
              getOptionLabel={(o) => o.Name}
              getOptionValue={(o) => o.Code}
              value={selectedClassifications}
              onChange={(opts) => {
                setSelectedClassifications(opts || []);
                setToSave(true);
              }}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          ) : (
            <div className="text-muted">Loading classifications...</div>
          )}
        </div>
      </div>
    );
  };

  const _drawCategoriesChoices = () => {
    return (
      <div className="row pt-3" style={{ cursor: "pointer" }}>
        <div className="col-xl">
          <h5 className="form-label">{t("dmsCategory", { ns: "labels" })}</h5>
          {dmsCategoriesVoc.length > 0 ? (
            <Select
              isMulti
              options={dmsCategoriesVoc}
              getOptionLabel={(o) => o.Name}
              getOptionValue={(o) => o.Code}
              value={selectedCategories}
              onChange={(opts) => {
                setSelectedCategories(opts || []);
                setToSave(true);
              }}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          ) : (
            <div className="text-muted">Loading categories...</div>
          )}
        </div>
      </div>
    );
  };

  const _drawValidationFlowChoices = () => {
    return (
      <div className="row pt-3">
        <div className="col-xl">
          <h5 className="form-label">{t("status", { ns: "labels" })}</h5>
          {dmsValidationFlowVoc.length > 0 ? (
            <Select
              isDisabled={userRights !== "approval"}
              isReadOnly={userRights !== "approval"}
              options={dmsValidationFlowVoc}
              getOptionLabel={(o) => o.Name}
              getOptionValue={(o) => o.Code}
              value={selectedValidation}
              onChange={(opts) => {
                setSelectedValidation(opts || []);
                setToSave(true);
              }}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          ) : (
            <div className="text-muted">Loading classifications...</div>
          )}
        </div>
      </div>
    );
  };

  const _drawFileKeywordsChoices = () => {
    return (
      <div className="row pt-3" style={{ cursor: "pointer" }}>
        <div className="col-xl">
          <h5 className="form-label">{t("keywords", { ns: "labels" })}</h5>
          <CreatableSelect
            isMulti
            options={
              (keywordsInput && keywordsInput.trim().length > 0
                ? [
              ...(Array.isArray(allKeywords) ? allKeywords : []),
              ...(Array.isArray(dmsFileKeywords) ? dmsFileKeywords : []),
              ...(Array.isArray(selectedFileKeywords) ? selectedFileKeywords : []),
              ]
                .map((k) => (k?.Keyword ?? k))
                .filter((k) => typeof k === "string")
                .map((k) => String(k).trim())
                .filter((k) => !!k)
                .filter((v, i, arr) => arr.indexOf(v) === i)
                .map((v) => ({ label: v, value: v }))
                : [])
            }
            value={(selectedFileKeywords || [])
              .map((k) => k?.Keyword ?? k)
              .filter((k) => typeof k === "string")
              .map((k) => String(k).trim())
              .filter((k) => !!k)
              .map((v) => ({ label: v, value: v }))}
            onInputChange={(value) => {
              setKeywordsInput(value);
              return value;
            }}
            onChange={(opts) => {
              const next = (opts || []).map((o) => ({ Keyword: o.value }));
              setSelectedFileKeywords(next);
              setToSave(true);
            }}
            className="basic-multi-select"
            classNamePrefix="select"
            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            menuPosition="fixed"
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              menu: (base) => ({
                ...base,
                zIndex: 9999,
                overflowY: "auto",
              }),
            }}
          />
        </div>
      </div>
    );
  };

  const _drawExpirationDate = () => {
    return (
      <div className="row pt-3 ">
        <div className="col-xl">
          <h5 htmlFor="expirationDateEdit" className="form-label">
            {t("expirationDate", { ns: "labels" })}
          </h5>
          <input
            style={{ cursor: "pointer", height: 38 }}
            onClick={() => {
              const el = document.getElementById("expirationDateEdit");
              if (el) {
                if (typeof el.showPicker === "function") {
                  el.showPicker();
                } else {
                  el.focus();
                  el.click();
                }
              }
            }}
            type="datetime-local"
            className="form-control"
            id="expirationDateEdit"
            value={
              item?.item?.ExpirationDate
                ? new Date(item.item.ExpirationDate).toISOString().slice(0, 16)
                : ""
            }
            onChange={(e) => {
              const iso = e.target.value
                ? new Date(e.target.value).toISOString()
                : null;
              setItem((prev) => ({
                ...prev,
                item: { ...prev.item, ExpirationDate: iso },
              }));
              setToSave(true);
            }}
          />
        </div>
      </div>
    );
  };

  const _drawFileName = () => {
    return (
      <div className="row pt-3">
        <div className="col-xl">
          <h5 htmlFor="itemNameRightModal" className="form-label">
            {t("fileName", { ns: "labels" })}
            <span className="text-danger">*</span>
          </h5>
          <input
            style={{ height: 38 }}
            type="text"
            className="form-control"
            id="itemNameRightModal"
            placeholder={t("name", { ns: "labels" })}
            value={item?.item?.Name || ""}
            onChange={(e) => {
              setItem((prev) => ({
                ...prev,
                item: { ...prev.item, Name: e.target.value },
              }));
              setToSave(true);
            }}
          />
        </div>
      </div>
    );
  };

  const formatLocalDateTime = (value) => {
    if (!value) return null;
    const date =
      value instanceof Date ? value : new Date(value);
    if (isNaN(date?.getTime?.())) return null;
    return date.toLocaleString();
  };

  const _drawCreatorLabel = () => {
    const creatorName = [
      item?.item?.ItemCreatedBy_Name,
      item?.item?.ItemCreatedBy_LastName,
    ]
      .filter(Boolean)
      .join(" ")
      .trim();
    const createdAt = formatLocalDateTime(item?.item?.ItemCreated);
    const label = creatorName
      ? createdAt
        ? `${creatorName} at ${createdAt}`
        : creatorName
      : createdAt
      ? `Created at ${createdAt}`
      : "N/A";
    return <span id="creatorLabelModal">{label}</span>;
  };

  const _drawLastUpdateLabel = () => {
    
      const updatedByName = [
        item?.item?.ItemLastUpdatedBy_Name,
        item?.item?.ItemLastUpdatedBy_LastName,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();
      const updatedAt = formatLocalDateTime(
        item?.item?.ItemLastUpdated
      );
      const label = updatedByName
        ? updatedAt
          ? `${updatedByName} at ${updatedAt}`
          : updatedByName
        : updatedAt
        ? `Updated at ${updatedAt}`
        : "N/A";
      return <span id="lastUpdateModal">{label}</span>;
    
  };
  const _drawOrganizationChoices = () => {
    return (
      <div className="row pt-3">
        <div className="col-xl">
          <h5 className="form-label">{t("businessUnit", { ns: "labels" })}</h5>
          <AsyncSelect cacheOptions loadOptions={searchOrganizationUnits}
            className="basic-multi-select"
            classNamePrefix="select"
            isClearable={true}
            menuPlacement="auto"
            menuPosition="fixed"
            placeholder="Type to search organizations"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 2000,
              }),
              menu: (base) => ({
                ...base,
                zIndex: 2000,
                overflowY: "auto",
              }),
              menuList: (base) => ({
                ...base,
                maxHeight: 160,
                paddingTop: 0,
                paddingBottom: 0,
              }),
              option: (base) => ({
                ...base,
                padding: "4px 8px",
                fontSize: "0.85rem",
                minHeight: "auto",
                lineHeight: 1.2,
              }),
              valueContainer: (base) => ({
                ...base,
                flexWrap: "nowrap",
              }),
            }} 
            value={selectedOrganizationUnitIds}
            onChange={(value) => {
              setSelectedOrganizationUnitIds(value);
              setToSave(true);
            }}
          />
          
          
        </div>
      </div>
    );
  };

  const _drawInfo = () => {
    return (
      <>
        <div className="row">
          <div className="col-6">
            <h5 className="mb-0">{t("creator", { ns: "labels" })}</h5>
            <span id="creatorLabelModal">
           {_drawCreatorLabel()}
            </span>
          </div>
          {item?.type === "file" && (
            <div className="col-6">
              <h5 className="mb-0">{t("fileSize", { ns: "labels" })}</h5>
              <span id="fileSizeRightModal">
                {item?.item?.FileSize ? getItemSize(item) : "N/A"}
              </span>
            </div>
          )}
        </div>
        <div className="row pt-3">
          <div className="col-6">
            <h5 className="mb-0">{t("lastUpdate", { ns: "labels" })}</h5>
           {_drawLastUpdateLabel()}
          </div>
          {item?.type === "file" && (
            <div className="col-6">
              <h5 className="mb-0">{t("fileType", { ns: "labels" })}</h5>
              <span id="fileTypeRightModal">
                {item?.item?.MimeType ? iconMapping(item.item.MimeType) : "N/A"}
              </span>
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <div className="offcanvas-body ">
        <div className="container-fluid p-0 m-0">
          {_drawInfo()}

          {item?.type === "file" && (
            <>
              {_drawFileName()}
              {_drawExpirationDate()}
              {_drawClassificationsChoices()}
              {_drawValidationFlowChoices()}
              {_drawOrganizationChoices()}
              {_drawFileKeywordsChoices()}
              {_drawCategoriesChoices()}
            </>
          )}

          <form>
            <div className="pt-3 ">
              <button className="btn btn-danger light  me-1" type="button" onClick={() => {
                closeOffcanvas();
              }}>
                {t("cancel", { ns: "labels" })}
              </button>
              <button
                id="saveRightEditModal"
                type="button"
                disabled={!toSave || isSavingRightEditModal}
                onClick={async (e) => {
                  e.preventDefault();
                  setIsSavingRightEditModal(true);
                  try {
                    await updateRightModalDetails();
                  } finally {
                    setIsSavingRightEditModal(false);
                  }
                }}
                className="btn btn-primary pl-3 "
              >
                {isSavingRightEditModal ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    
                    {t("save", { ns: "labels" })}
                  </>
                ) : (
                  
                  <>
                  {t("save", { ns: "labels" })}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default FileInfo;
